/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React from "react";

const Footer = ({ alter = true }) => {
  return (
    <footer
      style={{
        backgroundColor: alter ? "#1B6FBA" : "#fff",
      }}
    />
  );
};

export default Footer;
